import React from 'react';
import s from './chip.module.css';

const Chip = ({ label, selected, onClick }) => (
	<div className={`${s.mm} ${selected ? s.ss : {}}`} onClick={onClick}>
		<div className={s.label}>{label}</div>
	</div>
);

export default Chip;
